import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import dataFormSlice from "../features/dataForm/dataFormSlice";
import notificationSlice from "../features/notification/notificationSlice";
import parametriSlice from "../features/parametri/parametriSlice";
import sessionSlice from "../features/session/sessionSlice";

export const dataFormStore = configureStore({
	reducer: {
		dataForm: dataFormSlice,
		session:sessionSlice,
		notification:notificationSlice,
		parametri:parametriSlice
	},
	
});

export type AppDispatch = typeof dataFormStore.dispatch;
export type RootState = ReturnType<typeof dataFormStore.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
